export const DEFAULT_ERROR_MSG = 'Something went wrong';
export const COMMENT_TEXT_NOT_SPECIFIED = 'Comment text is not specified';
